/**
 * usePlan — hook React pour lire le plan courant depuis le Zustand userStore.
 * Équivalent de hooks/usePlan.ts de cvh-app, adapté pour Zustand.
 */
import { useUserStore } from '@store/userStore';
import { PLAN_LIMITS, type PlanKey } from '@/lib/plans';

export function usePlan() {
  const plan = (useUserStore((s) => s.profile?.plan) ?? 'free') as PlanKey;
  const limits = PLAN_LIMITS[plan];

  return {
    plan,
    limits,
    isEssential: plan === 'essential' || plan === 'pro',
    isPro:       plan === 'pro',
    isFree:      plan === 'free',
  };
}
